<template>
  <div class="pop-over">
    <div>
      <div class="description">
        {{ $t('conformation_incomplete_q') }}
      </div>



      <div @click="downloadData" class="download-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
          class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16">
          <path
            d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293V6.5z" />
          <path
            d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
        </svg>
        <div>{{$t('download') + filename}}</div>
      </div>

      <div class="button-footer">
        <div class="navigation-buttons">
          <button class="btn btn-outline-dark back" type="submit" @click="close">
            {{ $t('back_answering') }}
          </button>
        </div>

        <div class="navigation-buttons" @click="close">
          <router-link :to="{ name: 'home' }">
            <button class="btn btn-outline-dark next" type="submit">
              {{ $t('to_start') }}
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConformationPopup',
  data() {
    return {
      filename: ""
    };
  },
  methods: {
    close() {
      this.$emit("close");
      document.getElementById("content").classList.remove('active-blur');
    },
    downloadData() {
      const fileURL = window.URL.createObjectURL(new Blob([JSON.stringify(this.$store.state.answers)]));
      const fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', this.filename);
      document.body.appendChild(fileLink);

      fileLink.click();

    },
  },
  mounted() {
    const currentdate = new Date();
    this.filename = "MASS_detailed_answers" + currentdate.getDate() + "_"
      + (currentdate.getMonth() + 1) + "_"
      + currentdate.getFullYear() + '.txt';
  }
};
</script>

<style scoped>
.pop-over {
  background-color:  #f0f0f2;
  position: fixed;
  margin: auto;
  max-width: 600px;
  max-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  border-radius: 15px;

}

.button-footer {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  padding: 60px 10px 10px 0;
}

.btn {
  width: 180px;
}


.description {
  padding: 2rem;
  font-size: 1.2rem;
}

.download-container{
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 10px;
}
</style>